import React from 'react';
import styles from '../IntradaySignalTestPage.module.css';
import { IntradaySignalUpdate } from '../../types/trading';
import { CapFormState, SignalMode } from './signalConfig';
import { FrequencyControls } from './FrequencyControls';

const formatNumber = (value: number | null | undefined, digits = 6): string => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '--';
  return value.toFixed(digits);
};

const formatPercent = (value: number | null | undefined): string => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '--';
  return `${(value * 100).toFixed(4)}%`;
};

interface CapControlsProps {
  mode: Extract<SignalMode, 'percent_cap' | 'dollar_cap'>;
  form: CapFormState;
  onChange: (form: CapFormState) => void;
}

export const CapControls: React.FC<CapControlsProps> = ({ mode, form, onChange }) => {
  const unitSuffix = mode === 'percent_cap' ? '%' : '$';
  return (
    <>
      <label className={styles.control}>
        <span>Upper Limit ({unitSuffix})</span>
        <input
          value={form.upperLimitRaw}
          onChange={(e) => onChange({ ...form, upperLimitRaw: e.target.value })}
          type="number"
          step="any"
          placeholder="optional"
          className={styles.input}
        />
      </label>
      <label className={styles.control}>
        <span>Lower Limit ({unitSuffix})</span>
        <input
          value={form.lowerLimitRaw}
          onChange={(e) => onChange({ ...form, lowerLimitRaw: e.target.value })}
          type="number"
          step="any"
          placeholder="optional"
          className={styles.input}
        />
      </label>
      <FrequencyControls
        value={form.frequency}
        onChange={(frequency) => onChange({ ...form, frequency })}
      />
    </>
  );
};

interface CapResultsProps {
  mode: Extract<SignalMode, 'percent_cap' | 'dollar_cap'>;
  update: IntradaySignalUpdate | null;
}

export const CapResults: React.FC<CapResultsProps> = ({ mode, update }) => {
  return (
    <div className={styles.results}>
      <div className={styles.arrayCard}>
        <h2>Entry Price</h2>
        <pre>{formatNumber(update?.entry_price ?? null)}</pre>
        <p>First accepted sample (bucket close).</p>
      </div>
      <div className={styles.arrayCard}>
        <h2>Current Price</h2>
        <pre>{formatNumber(update?.current_price ?? null)}</pre>
        <p>Latest accepted sample (bucket close).</p>
      </div>
      <div className={styles.arrayCard}>
        <h2>Evaluation</h2>
        <p>Dollar Profit: {formatNumber(update?.dollar_profit ?? null, 4)}</p>
        {mode === 'percent_cap' ? (
          <p>Percentage Return: {formatPercent(update?.percentage_return ?? null)}</p>
        ) : null}
        <p>Hit Upper: {update?.hit_upper ? 'yes' : 'no'}</p>
        <p>Hit Lower: {update?.hit_lower ? 'yes' : 'no'}</p>
      </div>
    </div>
  );
};
